import React, { FC, ReactElement } from 'react';
import Image from 'next/image';
import classNames from 'classnames/bind';
import { Card } from 'sections/Events/components/EventCard/EventCard.types';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Events/components/EventCard/EventCard.module.scss';

const cn = classNames.bind(styles);

interface EventCardProps {
  cardsData: Card;
}

const EventCard: FC<EventCardProps> = ({ cardsData }): ReactElement => {
  const { width } = useWindowSize();
  const isOutdated = cardsData.registrationLink === '#';

  const Render = {
    CardImage: () => {
      if (width >= 876) {
        return (
          <Image
            alt={cardsData.imageAlt}
            src={cardsData.imageSrc}
            width={250}
            height={262}
            priority={cardsData.priority}
          />
        );
      }
      if (width < 876 && width > 575) {
        return (
          <Image
            alt={cardsData.imageAlt}
            src={cardsData.imageSrcTablet}
            width={99}
            height={262}
            priority={cardsData.priority}
          />
        );
      }
      if (width < 576) {
        return (
            <Image
            alt={cardsData.imageAlt}
            src={cardsData.imageSrcMobile}
            width={335}
            height={262}
            priority={cardsData.priority}
          />
        );
      }
    },
    CardButton: () => {
      return (
        <a
          className={cn('event-card__footer-button', { 'more-details': isOutdated })}
          href={cardsData.registrationLink}
        >
          {cardsData.buttonTitle}
        </a>
      );
    },
    CardContent: () => {
      return cardsData.list.map((item, index) => {
        if (item.img) {
          return (
            <div key={index} className={cn('event-card__list')}>
              <Image
                width={24}
                height={24}
                src={item.img}
                alt="icon"
                className={cn('event-card__list-image')}
              />
              <p className={cn('event-card__list-text')}>{item.text}</p>
            </div>
          );
        } else {
          return (
            <div key={index} className={cn('event-card__list')}>
              <a href={item.link} className={cn('event-card__list-link')}>
                {item.text}
              </a>
            </div>
          );
        }
      })
    },
  };

  const onCardClickHandler = () => {
    if (cardsData.pageLink !== '') {
      document.location.pathname = cardsData.pageLink;
    }
  };

  return (
    <div className={cn('event-card')} onClick={() => onCardClickHandler()}>

      <div className={cn('event-card__date')}>
        <h3 className={cn('event-card__date-heading-h3')}>{cardsData.date.month}</h3>
        <p className={cn('event-card__date-subtitle')}>{cardsData.date.days}</p>
      </div>

      <div className={cn('event-card__content')}>
        <div className={cn('event-card__image-box', `${cardsData.imageSrc}`)}>
          {Render.CardImage()}
        </div>

        <div className={cn('event-card__list-box')}>
          <h3 className={cn('event-card__list-heading')}>{cardsData.title}</h3>
          {Render.CardContent()}
        </div>

        <div className={cn('event-card__footer')}>
          <div className={cn('event-card__footer-button-box')}>
            {Render.CardButton()}
          </div>

          <div className={cn('event-card__footer-logo-box')}>
            <img width={81} height={18} src="/images/main/eventsMain/2.svg" alt="DF Alliance" />
            <img width={67} height={18} src="/images/main/eventsMain/3.svg" alt="DP World" />
          </div>
        </div>
      </div>

    </div>
  );
};

export { EventCard };
